import React from 'react';
import WhatsAppIcon from '../icons/WhatsApp.svg';
import './WhatsAppFloat.css';

const WhatsAppFloat = () => {
  return (
    <a 
      href="https://api.whatsapp.com/send?phone=9709072209"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Contact us on WhatsApp"
    >
      <img src={WhatsAppIcon} alt="WhatsApp" />
    </a>
  );
};

export default WhatsAppFloat; 